<template>
    <v-container fluid grid-list-md>
        <v-layout row wrap>
            <v-flex md12>
                <div class="mb-3">
                    <h2>Service Requirements</h2>
                    <service-requirements></service-requirements>
                </div>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import ServiceRequirements from '@/components/ServiceRequirements/ServiceRequirements';

export default {
    components: {
        ServiceRequirements
    }
};
</script>
